import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Link as RouterLink } from 'react-router-dom';

export const NotFoundPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundImage:
                    'url(https://images.unsplash.com/photo-1488921618671-463b781ac428?q=80&w=2070&auto=format&fit=crop)',
            }}
        >
            <Container maxWidth="md">
                <Paper
                    sx={{
                        p: 4,
                        backgroundColor: grey[200],
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h1">404</Typography>
                    <Typography variant="h2">Sorry, we couldn&apos;t find this page.</Typography>
                    <Button variant="contained" component={RouterLink} to="/" sx={{ maxWidth: 350 }}>
                        Take me back
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
};
